var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.displayItem),function(item,index){return _c('div',{key:index},[_c('standard-frame',{attrs:{"sub-title":item.title,"sub-content":item.content}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }